<div
  class="card"
  [id]="challenge().offerId"
  [style]="{
    border: config().border ? config().border : '',
    boxShadow: config().boxShadow ? config().boxShadow : '',
  }"
>
  <div
    class="card-header"
    role="img"
    [attr.aria-label]="config().header.backgroundImage.bannerAriaLabel"
    [style]="{
      backgroundImage: config().header.backgroundImage.url | transformUrl,
      height: config().height ? config().height : '',
    }"
  >
    @let firstLabel = config().body.firstLabel;
    @if (firstLabel) {
      <p
        class="first-label"
        [style]="{
          color: firstLabel.color,
          top: firstLabel.topPosition,
          textAlign: firstLabel.textAlign,
          fontFamily: firstLabel.fontFamily,
        }"
        [innerHTML]="firstLabel.text | replaceVars: challenge().target | safe"
      ></p>
    }

    @let secondLabel = config().body.secondLabel;
    @if (secondLabel) {
      <p
        class="second-label"
        [style]="{
          color: secondLabel.color,
          top: secondLabel.topPosition,
          textAlign: secondLabel.textAlign,
          fontFamily: secondLabel.fontFamily,
        }"
        [innerHTML]="
          secondLabel.text
            | replaceVars: challenge().target
            | replaceVars
              : (dataService.currentCampaign().startDate | date: 'd MMMM') || ''
            | replaceVars
              : (dataService.currentCampaign().endDate | date: 'd MMMM') || ''
            | replaceVars: challenge().rewardRatio
            | safe
        "
      ></p>
    }
  </div>
  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <p
        class="label"
        [style]="{
          color: labelConfig.color,
          fontFamily: labelConfig.fontFamily,
        }"
      >
        {{
          labelConfig.label | replaceVars: challenge().minAmountByTransaction
        }}
      </p>
    }
    @let subHeader = config().subHeader.picture;
    @if (subHeader && !challenge().isCompleted) {
      <div class="icon">
        <b2c-icon
          b2cElement
          [icon]="subHeader.imageUrl"
          [buttonTitle]="subHeader.alternativeText"
          (click)="displayInfoDialog(phase(), challenge())"
        />
      </div>
    }
  </div>

  <div
    class="card-content"
    data-variant="variant_2"
    data-cy="frequency-card-content"
  >
    @if (challenge().progress < challenge().target) {
      <!-- Card Body -->
      <div class="card-body">
        <div class="visits-container">
          <div class="number" data-cy="progress">
            {{ challenge().progress }}
          </div>
          <span class="slash"></span>
          <div class="number total" data-cy="target">
            {{ challenge().target }}
          </div>
          <div
            class="reward-ratio"
            [style]="{
              color: config().body.rewardRatio.color,
              fontFamily: config().body.rewardRatio.fontFamily,
            }"
          >
            <img
              [alt]="
                config().body.rewardRatio.rewardPicture.alternativeText
                  | replaceVars: challenge().rewardRatio
              "
              [src]="config().body.rewardRatio.rewardPicture.imageUrl"
            />
            <div class="reward-box">
              <span> {{ challenge().rewardRatio }}</span>
              @let rewardRatioPicture = config().body.rewardRatio.picture;
              @if (rewardRatioPicture) {
                <img
                  class="key-image"
                  [src]="rewardRatioPicture.imageUrl"
                  [alt]="rewardRatioPicture.alternativeText"
                />
              }
            </div>
          </div>
        </div>
        @let footer = config().footer;
        @if (footer) {
          <div
            class="remaining-orders"
            [style]="{
              color: footer.color,
              fontFamily: footer.fontFamily,
            }"
            [innerHTML]="
              footer.label
                | replaceVars: challenge().target - challenge().progress
                | safe
            "
          ></div>
        }

        <!-- Unselection Button -->
        @if (challenge().canBeUnselected(phase())) {
          <b2c-unselection-button
            [phase]="phase()"
            [challenge]="challenge()"
            class="unselect-challenge"
            [isBisCampaign]="isBisCampaign()"
            [isEventChallenge]="isEventChallenge()"
          />
        }
      </div>
    }

    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }

    <!-- Selection Button -->
    @if (!challenge().isSelected) {
      <div class="overlay">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          class="selection-button"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
